import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { LetDirective } from '@directives/app-let.directive';
import { Store } from '@ngrx/store';
import { StationNamePipe } from '@pipes/station-name/station-name.pipe';
import { selectStationsState } from '@selectors/station.selector';

@Component({
  selector: 'app-station-name',
  standalone: true,
  imports: [StationNamePipe, CommonModule, LetDirective],
  templateUrl: './station-name.component.html',
  styleUrls: ['./station-name.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StationNameComponent {
  stations$ = this.store.select(selectStationsState);

  @Input() includeCode = false;
  @Input() stationCode: string | undefined;
  @Input() codeClasses: string | undefined;
  @Input() stationClasses: string | undefined;
  @Input() stationCodeSpace: boolean = true;

  constructor(private store: Store) {}

  getMacOverride(code: string | undefined): string {
    if (code == 'JM1' || code == 'FL1' || code == 'SF1') {
      return 'ALL';
    }
    return code ?? '';
  }
}
